export const formatAmount = (amount: number, fraction: number = 2): string => {
  return new Intl.NumberFormat('ru-RU', { minimumFractionDigits: fraction, maximumFractionDigits: fraction })
    .format(amount)
    .replace(',', '.');
};
